export class PbxNumberPicker extends HTMLElement {
  constructor() {
    super();
    this.required = false;
  }
  connectedCallback() {
    this.required = !!this.dataset.required || false;
    console.log(this.required)
    this.innerHTML =
      `
      <div class="col-sm-7">
        <select class="form-control extension_type">
          <option value="null">Select</option>
          <option value="1">Toll Free</option>
          <option value="2">Local Number (Search by area code + prefix)</option>
        </select>
        <select class="form-control extension_toll_free hidden">
          <option value="null">Select</option>
          <option value="833">833</option>
          <option value="844">844</option>
          <option value="855">855</option>
          <option value="866">866</option>
          <option value="877">877</option>
          <option value="888">888</option>
        </select>
        <div class="exension_local hidden">
          <input class="form-control extension_local_number">
          <div class="col-sm-12 no-gutters">
            <select class="form-control available_local_numbers hidden"></select>
          </div>
          <div class="col-sm-12" id="availability"></div>
        </div>
      </div>
      `;

    $(this.querySelector(".extension_local_number")).mask('(999) 999-XXXX');
    this.querySelector('.extension_type').onchange = (e) => {this.handleNumberType(e.target.value)}
    this.initLocalNumbers();
  }

  handleNumberType(val) {
    if(val == 1) {
      this.querySelector('.extension_toll_free').classList.remove('hidden');
      this.querySelector('.exension_local').classList.add('hidden');
    } else if (val == 2) {
      this.querySelector('.extension_toll_free').classList.add('hidden');
      this.querySelector('.exension_local').classList.remove('hidden');
    } else {
      this.querySelector('.extension_toll_free').classList.add('hidden');
      this.querySelector('.exension_local').classList.add('hidden');
    }
  }

  initLocalNumbers() {
    let numField = this.querySelector(".extension_local_number")
    numField.addEventListener("keyup", async function(e) {
      this.valid=false
      // ajax to get available number count
      numField.classList.remove("error");
      this.querySelector('.available_local_numbers').classList.remove("error");
      this.querySelector(".available_local_numbers").innerHTML = "";
      let request = e.target.value.replace(/\D/g,'');
      request.length < 6 ? this.querySelector(".available_local_numbers").classList.add("hidden") : this.querySelector(".available_local_numbers").classList.remove("hidden");
      let numRequired = 1;
      if(request.length == 6) {
        console.log('before fetch')
        let res = await fetch(`/admin/campaigns/local_number_search?number=${request}&quantity=${numRequired}`);
        this.availableNums = await res.json();
        console.log(this.availableNums)
        // If only one available number group is returned that is all we have to work with. Otherwise user can select which NPANXX they want.
        if(this.availableNums.length > 0) {
          this.querySelector("#availability").innerHTML = "";
          this.querySelector("#availability").classList.add('hidden');
          this.npanxx_selects = this.availableNums.map(function(availNum) { 
            let split_npa_nxx = availNum.npanxx.match(/^(\d{3})(\d{3})$/);
            return `<option value=${availNum.npanxx}>(${split_npa_nxx[1]}) ${split_npa_nxx[2]}-XXXX</option>` 
          })//.join("");
          this.npanxx_index = 0;
          this.refreshOptions();
        } else {
          this.querySelector(".available_local_numbers").classList.add('hidden');
          this.querySelector("#availability").classList.remove('hidden');
          this.querySelector("#availability").innerHTML = '<span style="color:red;">No numbers found</span>';
        }
      }
    }.bind(this));
  }

  refreshOptions() {
    let npanxx_options = [];
    for(let i = this.npanxx_index; i < this.npanxx_index+5; i++) {
      this.npanxx_selects[i] ? npanxx_options.push(this.npanxx_selects[i]) : null
    }
    this.querySelector(".available_local_numbers").innerHTML = `<option value>Select</option>${npanxx_options.join("")}`
    this.npanxx_index < this.npanxx_selects.length - 5 ? this.npanxx_index += 5 : this.npanxx_index = 0;
  }

  getData() {
    let number = null;
    if(this.querySelector('.extension_type').value != 'null') {
      number = {}
      if(this.querySelector('.extension_type').value == 1) {
        number.local_numbers = false
        number.npanxx = this.querySelector('.extension_toll_free').value;
      }
      if(this.querySelector('.extension_type').value == 2) {
        number.local_numbers = true
        number.npanxx = this.querySelector('.available_local_numbers').value;
      }
    }

    return number
  }

  validate() {
    let validationData = {
      isValid: true
    };
    this.querySelector('.extension_type').classList.remove('error');
    this.querySelector('.extension_toll_free').classList.remove('error');
    this.querySelector('.available_local_numbers').classList.remove('error');

    if(this.required && this.querySelector('.extension_type').value == 'null') {
      this.querySelector('.extension_type').classList.add('error');
      validationData.isValid = false;
      validationData.type = 'none';
    }
    if(this.querySelector('.extension_type').value == 1 && this.querySelector('.extension_toll_free').value == 'null') {
      this.querySelector('.extension_toll_free').classList.add('error');

      validationData.isValid = false;
      validationData.type = 'toll-free';
    }
    if(this.querySelector('.extension_type').value == 2 && !this.querySelector('.available_local_numbers').value) {
      if(!this.querySelector('.extension_local_number').value) {
        this.querySelector('.extension_local_number').classList.add('error');
      }
      if(!this.querySelector('.available_local_numbers').value) {
        this.querySelector('.available_local_numbers').classList.add('error');
      }

      validationData.isValid = false;
      validationData.type = 'local';
    }

    return validationData
  }
}

customElements.define('pbx-number-picker', PbxNumberPicker)